/**
 * CPFs autorizados a cadastrar/editar sistemas (tela /criar-sistema).
 *
 * É uma tela de manutenção interna, por isso a liberação é por CPF e não por
 * perfil. Mantenha esta lista como ÚNICA fonte: a rota (app.routes.tsx) e o
 * botão que leva até ela usam a mesma função, então nunca aparece um botão
 * apontando para uma rota que não existe para aquele usuário.
 */
const CPFS_CRIAR_SISTEMA = [
  "03878626096",
  "03411614030",
  "03914978040",
];

export function podeCriarSistema(usuario?: {
  cpf?: string | null;
  administrador?: boolean | number;
}): boolean {
  if (!usuario?.administrador) return false;
  return ehCpfDeManutencao(usuario.cpf);
}

/**
 * O CPF está na lista de manutenção?
 *
 * Separado do `podeCriarSistema` porque não exige `administrador`: quem é da
 * manutenção pode chegar numa entidade onde ainda não tem conta — e portanto
 * não é administrador lá — e ainda assim precisa se registrar.
 */
export function ehCpfDeManutencao(cpf?: string | null): boolean {
  // compara só os dígitos — funciona com ou sem máscara
  const digitos = String(cpf ?? "").replace(/\D/g, "");
  return digitos.length > 0 && CPFS_CRIAR_SISTEMA.includes(digitos);
}

/**
 * CPFs da EQUIPE SINSOFT — espelho de `UNICO_LOGIN/src/Utils/cpfsSinsoft.ts`.
 *
 * Hoje só quem está aqui pode liberar/remover o acesso de um usuário a um
 * sistema (Perfil > etapa "Sistemas" e o modal de usuários no card da home).
 *
 * ⚠️ Esta lista NÃO é a trava — só desabilita controle na tela. A decisão é do
 * servidor, que recusa as rotas de /sistema-usuario com 403. Se mexer aqui,
 * mexa lá também, senão a tela promete uma ação que a API vai negar.
 */
const CPFS_SINSOFT = [
  "00639752039", // Bruno Bertolini
  "02549143060", // Carla Fagundes de Souza
  "81810547091", // Jonas Tonial
  "03878626096", // Kaido Muller (cadastrado também como "Ricardo Muller")
  "91670594068", // Marcia Regina Paese
  "03411614030", // Ricardo Pinto Giasson Filho
  "90309553091", // Rodrigo Beltrame Bordin
  "03914978040", // Pedro Lourensi Giasson
];

/**
 * Pode liberar/remover o acesso de um usuário a um sistema?
 *
 * Não exige `administrador`: o vínculo é por CPF, e a equipe pode estar numa
 * entidade onde ainda não foi marcada como administradora.
 */
export function podeLiberarSistema(usuario?: { cpf?: string | null }): boolean {
  const digitos = String(usuario?.cpf ?? "").replace(/\D/g, "");
  return digitos.length > 0 && CPFS_SINSOFT.includes(digitos);
}
